import React from 'react';
import { InnerScreenGrid } from '../atoms/dumb';
import { Header } from '../molecules/dumb';
import * as Organisms from '../organisms';
import { localI18n } from '../../i18n';
const uxCopy = {
  header: localI18n._("Manage Collaborators")
};
const CollaboratorPage = ({
  onBack
}) => React.createElement(InnerScreenGrid, null, React.createElement(Header, {
  onBack: onBack
}, uxCopy.header), React.createElement(Organisms.Smart.IndividualAccess, null), React.createElement(Organisms.Smart.FooterSimple, null));
export default CollaboratorPage;